import { CollectPermission } from "generated/graphql";

interface CollectPermissionObject {
  value: CollectPermission;
  name: string;
}

export const ALL_COLLECT_PERMISSIONS: CollectPermissionObject[] = Object.entries(CollectPermission).map(
  ([name, value]) => ({
    name,
    value,
  })
);
